/**
 * Stable API message `code` wire values (Phase A inventory).
 * Mirrors backend `ApiMessageCodes` — string values are lowercase snake_case.
 * @see docs/domains/platform/backendI18n/phaseACodes.md
 */
export const ApiMessageCodes = {
  // Gates and clinical access
  trialExpired: "trial_expired",
  paymentRequired: "payment_required",
  billingOnly: "billing_only",
  orgBillingBlocked: "org_billing_blocked",
  accountClosed: "account_closed",
  notAuthenticated: "not_authenticated",
  forbidden: "forbidden",

  // Consent / legal acceptance
  consentRequired: "consent_required",

  // Plan-adjustment notice
  planAdjustmentBasic: "plan_adjustment_basic",
  planAdjustmentFree: "plan_adjustment_free",
  planAdjustmentGeneric: "plan_adjustment_generic",

  // Billing / subscription / entitlements
  planLimitPatients: "plan_limit_patients",
  planStorageUnavailable: "plan_storage_unavailable",
  planStorageLimit: "plan_storage_limit",
  moduleFinanceUnavailable: "module_finance_unavailable",
  moduleSecretaryUnavailable: "module_secretary_unavailable",
  moduleAiReportsUnavailable: "module_ai_reports_unavailable",
  catalogPlanUnavailable: "catalog_plan_unavailable",
  catalogModuleUnavailable: "catalog_module_unavailable",
  billingPaymentFailed: "billing_payment_failed",
  billingPaymentMethodChangeFailed: "billing_payment_method_change_failed",
  billingTrialCancelUnavailable: "billing_trial_cancel_unavailable",
  conflict: "conflict",
  internalError: "internal_error",

  // Auth (highest-traffic)
  sessionExpired: "session_expired",
  authInvalidCredentials: "auth_invalid_credentials",
  authEmailAlreadyRegistered: "auth_email_already_registered",
  authNameTooShort: "auth_name_too_short",
  authInvalidPreferredLocale: "auth_invalid_preferred_locale",
  authInviteInvalid: "auth_invite_invalid",
  authInviteTokenRequired: "auth_invite_token_required",
  authEmailConfirmFailed: "auth_email_confirm_failed",
  authEmailRequired: "auth_email_required",
  authEmailInvalid: "auth_email_invalid",
  authNameRequired: "auth_name_required",
  authPasswordRequired: "auth_password_required",
  authPasswordWeak: "auth_password_weak",
  authSpecialtyInvalid: "auth_specialty_invalid",
  authSpecialtyImmutable: "auth_specialty_immutable",
  authClinicRegisterUnavailable: "auth_clinic_register_unavailable",
  authRegistrationTypeInvalid: "auth_registration_type_invalid",
  authSignupPlanInvalid: "auth_signup_plan_invalid",

  // Clinic (highest-traffic)
  clinicContextMissing: "clinic_context_missing",
  clinicForbidden: "clinic_forbidden",
  clinicMemberNotFound: "clinic_member_not_found",
  clinicMemberNotTherapist: "clinic_member_not_therapist",
  clinicMemberAlreadyActive: "clinic_member_already_active",
  clinicCannotDeactivateSelf: "clinic_cannot_deactivate_self",
  clinicPrimaryPatientsBlockDeactivate: "clinic_primary_patients_block_deactivate",
  clinicMemberRolesRequired: "clinic_member_roles_required",
  contaForbiddenClinicStaff: "conta_forbidden_clinic_staff",
  contaRequiresAssinaturaCancel: "conta_requires_assinatura_cancel",
} as const;

export type ApiMessageCode = (typeof ApiMessageCodes)[keyof typeof ApiMessageCodes];

export const API_MESSAGE_CODE_VALUES: readonly ApiMessageCode[] = Object.values(ApiMessageCodes);
